import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Drawer, useMediaQuery, Divider, Typography } from '@material-ui/core';
import useAuth from '../../hooks/useCustomAuth';
import NavSection from '../NavSection';
import Scrollbar from '../Scrollbar';
// import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import { useTranslation } from 'react-i18next';
import {
  AccountTree as AccountTreeIcon,
  AssignmentInd as AssignmentIndIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  // StarHalf as StarHalfIcon,
  PermIdentity as PermIdentityIcon,
  People as PeopleIcon,
  Search as SearchIcon,
  AccessTime as AccessTimeIcon,
  BeachAccess as BeachAccessIcon,
  //TrackChanges as TrackChangesIcon,
  Tune as TuneIcon,
  Article as ArticleIcon,
  CalendarToday as CalendarTodayIcon,
  AssignmentTurnedIn as AssignmentIcon,
  LocationSearching as LocationIcon,
  RecentActors,
  Map,
  School as SchoolIcon,
  Apartment as ApartmentIcon,
  BarChart as BarChartIcon,
  Schema as SchemaIcon,
  Group as GroupIcon,
  Forum as ForumIcon
} from '@material-ui/icons';
import * as userPermissions from '../../consts/userRoles';

const sections = [
  {
    title: 'menu:personalArea.main',
    role: userPermissions.PORTAL,
    items: [
      {
        title: 'menu:personalArea.main',
        role: userPermissions.PORTAL,
        children: [
          {
            title: 'menu:personalArea.profile',
            path: '/dashboard/profile/myProfile',
            icon: <PermIdentityIcon fontSize="small" />,
            role: userPermissions.PORTAL_PROFILE_REGISTRATION
          },
          {
            title: 'menu:personalArea.timesheet',
            path: '/dashboard/profile/myTimesheet',
            icon: <AccessTimeIcon fontSize="small" />,
            role: userPermissions.PORTAL_PROFILE_HOURS
          },
          {
            title: 'menu:personalArea.vacations',
            path: '/dashboard/profile/myVacations',
            icon: <BeachAccessIcon fontSize="small" />,
            role: userPermissions.PORTAL_PROFILE_VACATIONS
          },
          {
            title: 'menu:personalArea.vacations',
            path: '/dashboard/profile/myVacationsApproval',
            icon: <BeachAccessIcon fontSize="small" />,
            role: userPermissions.PORTAL_PROFILE_AUTO_APPROVAL_VACATIONS
          },
          {
            title: 'menu:personalArea.goalsOverview',
            path: '/dashboard/evaluation/Objectives/MyObjectives/',
            icon: <AssignmentIcon fontSize="small" />,
            role: "9999"
          },
          // {
          //   title: process.env.REACT_APP_MENU_NAME_PERIODIC_EVALUATION ? process.env.REACT_APP_MENU_NAME_PERIODIC_EVALUATION : 'menu:personalArea.periodicEvaluation',
          //   path: '/dashboard/evaluation/PeriodicEvaluation/MyEvaluation',
          //   icon: <StarHalfIcon fontSize="small" />,
          //   role: "9999"
          // },
          {
            title: 'menu:personalArea.performanceEvaluation',
            path: '/dashboard/evaluation/YearlyEvaluation/MyEvaluation?evaluationType=TYPE_PERFORMANCE',
            icon: <StarIcon fontSize="small" />,
            role: userPermissions.PORTAL_PERF_EVAL_DASHBOARD
          },
          {
            title: 'menu:personalArea.feedbackEvaluation',
            path: '/dashboard/evaluation/YearlyEvaluation/MyEvaluation?evaluationType=TYPE_FEEDBACK_CONTINUOUS',
            icon: <GroupIcon fontSize="small" />,
            role: userPermissions.PORTAL_PERF_EVAL_DASHBOARD
          },
          {
            title: 'menu:personalArea.documentManagement',
            path: '/dashboard/evaluation/PipelineDocuments/MyDocuments',
            icon: <ArticleIcon fontSize="small" />,
            role: userPermissions.PORTAL_EVALUATION_DOCUMENTS_MANAGEMENT
          },
          {
            title: 'menu:personalArea.training',
            path: '/dashboard/training/list',
            icon: <SchoolIcon fontSize="small" />,
            role: userPermissions.PORTAL_PROFILE_TRAINING
          },
          // {
          //   title: 'menu:personalArea.myFollowUp',
          //   path: '/dashboard/evaluation/PeriodicEvaluation/MyEvaluation',
          //   icon: <StarHalfIcon fontSize="small" />,
          //   role: userPermissions.PORTAL_PERF_EVAL_DASHBOARD
          // },
        ]
      }
    ]
  },
  {
    title: 'Team',
    role: [userPermissions.PORTAL_TEAM_VACATIONS_APPROVAL, userPermissions.PORTAL_PERF_EVAL_TEAM, userPermissions.PORTAL_EVAL_TEAM_DASHBOARD],
    items: [
      {
        title: 'menu:team.main',
        role: [userPermissions.PORTAL_TEAM_VACATIONS_APPROVAL, userPermissions.PORTAL_PERF_EVAL_TEAM, userPermissions.PORTAL_EVAL_TEAM_DASHBOARD],
        children: [
          {
            title: 'menu:team.vacationsApproval',
            path: '/dashboard/team/vacationApproval',
            icon: <BeachAccessIcon fontSize="small" />,
            role: userPermissions.PORTAL_TEAM_VACATIONS_APPROVAL
          },
          {
            title: 'menu:team.vacationsMap',
            path: '/dashboard/team/vacations',
            icon: <CalendarTodayIcon fontSize="small" />,
            role: userPermissions.PORTAL_TEAM_VACATIONS_APPROVAL
          },
          {
            title: 'menu:team.performanceEvaluation',
            path: '/dashboard/evaluation/YearlyEvaluation/TeamEvaluation',
            icon: <StarIcon fontSize="small" />,
            role: userPermissions.PORTAL_PERF_EVAL_TEAM
          },
          {
            title: "menu:team.dashboardKPI",
            path: '/dashboard/team/evaluation/YearlyEvaluation/DashboardKPI',
            icon: <BarChartIcon fontSize="small" />,
            role: userPermissions.PORTAL_EVAL_TEAM_DASHBOARD
          },
          // {
          //   title: 'menu:team.monitorization',
          //   path: '/dashboard/evaluation/PeriodicEvaluation/TeamEvaluation',
          //   icon: <StarHalfIcon fontSize="small" />,
          //   role: userPermissions.PORTAL_PERF_EVAL_TEAM
          // },
        ]
      }
    ]
  },
  {
    title: 'menu:hr.main',
    role: [userPermissions.PORTAL_PERF_EVAL_ADMINISTRATION, userPermissions.PORTAL_EVAL_ADMIN_DASHBOARD, userPermissions.PORTAL_FEEDBACK_CONTINUOUS_LIST],
    items: [
      {
        title: 'menu:hr.main',
        role: [userPermissions.PORTAL_PERF_EVAL_ADMINISTRATION, userPermissions.PORTAL_EVAL_ADMIN_DASHBOARD, userPermissions.PORTAL_FEEDBACK_CONTINUOUS_LIST],
        path: '/dashboard/evaluation',
        children: [
          {
            title: 'menu:hr.dashboard',
            path: '/dashboard/evaluation/dashboard',
            icon: <BarChartIcon fontSize="small" />,
            role: userPermissions.PORTAL_PERF_EVAL_ADMINISTRATION
          },
          {
            title: 'menu:hr.evaluationPlanning',
            path: '/dashboard/evaluation/EvaluationPlanning',
            icon: <StarBorderIcon fontSize="small" />,
            role: userPermissions.PORTAL_PERF_EVAL_ADMINISTRATION
          },
          {
            title: 'menu:hr.performanceEvaluation',
            path: '/dashboard/admin/evaluation/YearlyEvaluation/dashboard',
            icon: <StarIcon fontSize="small" />,
            role: userPermissions.PORTAL_PERF_EVAL_ADMINISTRATION
          },
          {
            title: 'menu:hr.feedbackContinuousList',
            path: '/dashboard/admin/evaluation/FeedbackContinuous',
            icon: <ForumIcon fontSize="small" />,
            role: userPermissions.PORTAL_FEEDBACK_CONTINUOUS_LIST
          },
          {
            title: 'menu:team.objAndComptDef',
            path: '/dashboard/evaluation/Objectives/ObjectivesManagement/',
            icon: <TuneIcon fontSize="small" />,
            role: userPermissions.PORTAL_GOALS_MANAGEMENT
          },
          {
            title: 'menu:hr.vacations',
            path: '/dashboard/hr/vacations',
            icon: <BeachAccessIcon fontSize="small" />,
            role: userPermissions.PORTAL_VACATIONS_ADMINISTRATION
          },
          {
            title: 'menu:admin.vacationsMap',
            path: '/dashboard/admin/vacations',
            icon: <CalendarTodayIcon fontSize="small" />,
            role: userPermissions.PORTAL_TEAM_VACATIONS_APPROVAL
          },
          {
            title: "menu:admin.dashboardKPI",
            path: '/dashboard/admin/evaluation/YearlyEvaluation/DashboardKPI',
            icon: <BarChartIcon fontSize="small" />,
            role: userPermissions.PORTAL_EVAL_ADMIN_DASHBOARD
          }
        ]
      }
    ]
  },
  {
    title: 'menu:CCA.main',
    role: userPermissions.PORTAL_EVALUATION_CCA_EVALUATION_SAVE,
    items: [
      {
        title: 'menu:CCA.main',
        role: userPermissions.PORTAL_EVALUATION_CCA_EVALUATION_SAVE,
        path: '/dashboard/evaluation',
        children: [
          {
            title: 'menu:CCA.harmonizations',
            path: '/dashboard/evaluation/harmonizations/',
            icon: <RecentActors fontSize="small" />,
            role: userPermissions.PORTAL_EVALUATION_CCA_EVALUATION_SAVE,
            moduleID: 'HARMONIZATION'
          }
        ]
      }
    ]
  },
  {
    title: 'menu:learningJourney.main',
    role: userPermissions.PORTAL_ADMINISTRATION_TRAINING,
    items: [
      {
        title: 'menu:learningJourney.main',
        role: userPermissions.PORTAL_ADMINISTRATION_TRAINING,
        path: '/dashboard/learningJourney',
        children: [
          {
            title: 'menu:learningJourney.dashboard',
            path: '/dashboard/learningJourney/dashboard',
            icon: <BarChartIcon fontSize="small" />,
            role: userPermissions.PORTAL_ADMINISTRATION_TRAINING
          },
          {
            title: 'menu:hr.competenciesCatalog',
            path: '/dashboard/evaluation/Competencies/CompetenciesCatalog',
            icon: <LocationIcon fontSize="small" />,
            role: userPermissions.PORTAL_PERF_EVAL_ADMINISTRATION
          },
          {
            title: 'menu:hr.trainingManagement',
            path: '/dashboard/hr/trainingCatalogue',
            icon: <SchoolIcon fontSize="small" />,
            role: userPermissions.PORTAL_ADMINISTRATION_TRAINING
          },
        ]
      }
    ]
  },
  {
    title: 'Recruitment',
    role: userPermissions.PORTAL_RECRUITMENT_ACCESS,
    items: [
      {
        title: 'RECRUTAMENTO',
        role: userPermissions.PORTAL_RECRUITMENT_ACCESS,
        path: '/dashboard/recruitment',
        children: [
          {
            title: 'menu:recruitment.processes',
            path: '/dashboard/recruitment/process',
            icon: <SearchIcon fontSize="small" />,
            role: userPermissions.PORTAL_RECRUITMENT_PROCESS
          },
          {
            title: 'menu:recruitment.opportunities',
            icon: <AccountTreeIcon fontSize="small" />,
            path: '/dashboard/recruitment/opportunities',
            role: userPermissions.PORTAL_RECRUITMENT_OPPORTUNITY
          },
          {
            title: 'As minhas Oportunidades',
            icon: <AccountTreeIcon fontSize="small" />,
            path: '/dashboard/recruitment/myOpportunities',
            role: userPermissions.PORTAL_RECRUITMENT_OPPORTUNITY_FILTERED
          },
          {
            title: 'menu:recruitment.candidates',
            icon: <AssignmentIndIcon fontSize="small" />,
            path: '/dashboard/recruitment/candidates',
            role: userPermissions.PORTAL_RECRUITMENT_OPPORTUNITY
          },
          {
            title: 'menu:recruitment.staffReportHR',
            icon: <Map fontSize="small" />,
            path: '/dashboard/recruitment/staffReportRh',
            role: userPermissions.PORTAL_RECRUITMENT_STAFF_REPORT_MANAGEMENT,
            moduleID: 'STAFFREPORT'
          },
        ]
      }
    ]
  },
  {
    title: "BACKOFFICE",
    role: userPermissions.PORTAL_BACKOFFICE,
    items: [
      {
        title: 'BACKOFFICE',
        role: userPermissions.PORTAL_BACKOFFICE,
        children: [
          {
            title: 'menu:admin.employees',
            path: '/dashboard/admin/employees/',
            icon: <PeopleIcon fontSize="small" />,
            role: userPermissions.PORTAL_BACKOFFICE_EMPLOYEE
          },
          {
            title: 'menu:admin.entities',
            path: '/dashboard/admin/entities/',
            icon: <ApartmentIcon fontSize="small" />,
            role: userPermissions.PORTAL_BACKOFFICE_ENTITIES
          },
          {
            title: 'menu:admin.companyMap',
            path: '/dashboard/admin/companyMap/',
            icon: <SchemaIcon fontSize="small" />,
            role: userPermissions.PORTAL_BACKOFFICE_COMPANY_MAP
          },
        ]
      }
    ]
  },
  {
    title: "menu:admin.main",
    role: userPermissions.PORTAL_ADMINISTRATION,
    items: [
      {
        title: 'menu:admin.main',
        role: userPermissions.PORTAL_ADMINISTRATION,
        children: [
          {
            title: 'menu:admin.roles',
            path: '/dashboard/admin/roleConfiguration',
            icon: <StarIcon fontSize="small" />,
            role: userPermissions.PORTAL_ADMINISTRATION_ROLES
          },
          // {
          //   title: 'menu:admin.projects',
          //   path: '/dashboard/admin/projects',
          //   icon: <LaptopMacIcon fontSize="small" />,
          //   role: userPermissions.PORTAL_ADMINISTRATION
          // },
          // {
          //   title: 'menu:admin.timesheetApproval',
          //   path: '/dashboard/admin/timesheet',
          //   icon: <AccessTimeIcon fontSize="small" />,
          //   role: userPermissions.PORTAL_ADMINISTRATION_HOURS_CONTROL
          // },
        ]
      }
    ]
  }
];

const DashboardSidebar = (props) => {
  const { onCloseSidebar, openSidebar } = props;
  const location = useLocation();
  const { user } = useAuth();
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { t } = useTranslation();

  useEffect(() => {
    if (openSidebar && onCloseSidebar && lgDown) {
      onCloseSidebar();
    }
  }, [location.pathname]);

  const hasPermission = (role) => {
    if (Array.isArray(role)) {
      return user.roles.some(r => role.indexOf(r) >= 0)
    }
    return user.roles.includes(role)
  }

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Scrollbar options={{ suppressScrollX: true }}>
        <Box
          sx={{
            display: {
              lg: 'none',
              xs: 'flex'
            },
            justifyContent: 'center'
          }}
        >
          <RouterLink to="/">
            <Box
              sx={{
                '& img': {
                  width: 100,
                  height: 36
                }
              }}
            >
              <img
                alt={process.env.REACT_APP_PLATFORM_NAME}
                src="/static/logo.svg"
              />
            </Box>
          </RouterLink>
        </Box>
        <Box>
          {sections.filter((x) => (hasPermission(x.role) && (!x.moduleID || (x.moduleID !== "" && user.userModules?.find(m => m.id === x.moduleID)?.enable))) || (!x.role && process.env.NODE_ENV === 'development')).map((section, section_index) => (
            <NavSection
              key={section.title + "_" + section_index}
              pathname={location.pathname}
              {...section}
            />
          ))}
        </Box>
      </Scrollbar>

      <Divider sx={{ borderColor: "#e0e0e033" }} />
      <Box
        sx={{
          py: 2,
          px: 3
        }}
      >
        <Typography
          align="center"
        >
          {t("common:common.version")} {process.env.REACT_APP_BUILD_BUILDNUMBER}.{process.env.REACT_APP_ASPNETCORE_ENVIRONMENT === "QA" ? "1" : "0"}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="left"
      onClose={onCloseSidebar}
      open={openSidebar}
      PaperProps={{
        sx: {
          backgroundColor: 'background.paper',
          width: "256px",
          paddingTop: lgDown ? "initial" : "65px"
        }
      }}
      variant={lgDown ? "temporary" : "persistent"}
    >
      {content}
    </Drawer>
  );
};

DashboardSidebar.propTypes = {
  onCloseSidebar: PropTypes.func,
  openSidebar: PropTypes.bool
};

export default DashboardSidebar;
